/**
 * form-section-title.js
 */

import React from 'react';
import { FormLabel } from '@mui/material';


export default function FormSectionTitle(props) {
  return (
    <FormLabel 
      component="legend" 
      {...props}
    >
      {props.children}
    </FormLabel>
  );
}